// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { autocompleteProductsStyles } from "@eisinc/Overrides/Widgets/Header/AutocompleteProducts";
import { xScreen } from "@eisinc/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const productContainerStyle = css`
    display: flex;
    justify-content: flex-end;
    margin: 0;
    padding: 15px;
    cursor: pointer;
    width: 50%;
    flex: 0 1 50%;
    text-align: left;
    border-bottom: 1px solid ${getColor("common.ui3")};
    ${xScreen("lte", "lg")} {
        width: 100%;
        flex: 1 1 100%;
    }

    ${xScreen("lte", "md")} {
        width: 50%;
        flex: 0 1 50%;
    }

    ${xScreen("lte", "sm")} {
        width: 100%;
        flex: 1 1 100%;
    }
`;


autocompleteProductsStyles.wrapper = {
    css: productContainerStyle,
};
autocompleteProductsStyles.focusedWrapper = {
    css: css`
            ${productContainerStyle}
            background-color: lightgray;
        `,
};
autocompleteProductsStyles.image = {
    width: "75px",
    height: "75px",
    css: css`
            flex: 0 0 75px;
            margin-right: 10px;
            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        `,
};
autocompleteProductsStyles.productDetailsWrapper = {
    css: css`
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            @media (max-width: 481px) {
                flex-wrap: wrap;
            }
        `,
};
autocompleteProductsStyles.productNumbersWrapper = {
    css: css`
            flex: 1 1 auto;
            line-height: 1;

            > .product-num {
                display: flex;
            }
            @media (max-width: 481px) {
                width: 100%;
            }
        `,
};
autocompleteProductsStyles.productNumberLabel = {
    size: "12px",
    lineHeight: "13px",
    weight: "bold",
    css: css`
            white-space: nowrap;
        `,
};
autocompleteProductsStyles.productNumber = {
    size: "12px",
    lineHeight: "13px",
};
autocompleteProductsStyles.productActionsWrapper = {
    css: css`
            display: flex;
            flex: 0 0 auto;
            column-gap: 10px;
            @media (max-width: 481px) {
                margin-top: 10px;
            }
        `,
};
autocompleteProductsStyles.infoWrapper = {
    css: css`
            display: flex;
            flex-direction: column;
            max-width: calc(100% - 85px);
            flex-basis: calc(100% - 85px);

            .choose-from-options {
                height: 32px;
                min-height: 32px;
                margin-top: 10px;
            }
        `,
};
autocompleteProductsStyles.titleLink = {
    color: "text.main",
    typographyProps: {
        size: "14px",
        lineHeight: "18px",
        css: css`
                width: 100%;
                margin: 0 0 10px 0;
                text-transform: uppercase;
            `,
    },
};
autocompleteProductsStyles.extendedQtyFieldStyles = {
    cssOverrides: {
        formField: css`
                margin-right: 10px;
                height: 32px;
                width: 52px;
                text-align: center;
            `,
        inputSelect: css`
                height: 32px;
                text-align: center;
            `,
    },
};
autocompleteProductsStyles.extendedAddToCartStyles = {
    css: css`
            height: 26px;
            min-height: 26px !important;
            line-height: 14px;
            width: 45px;
        `,
};

